import { Address } from '../forms/address/types';

function testAddressEquality(address1: Address, address2: Address): boolean {
  if (address1 && address2) {
    return Object.entries(address1).every(
      ([key, value]) => address2[key as keyof Address] === value,
    );
  }
  return false;
}

export default { testAddressEquality };
